import React from 'react'
import { connect } from 'react-redux'
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  FormGroup, TextField
} from '@mui/material'
import { formUpdate } from '../../lib/form'
import { rxOpenTag } from '../../lib/rx_subject'
import { sendWs, TAG } from '../../lib/send'

const Tag = ({ tag, user }) => {
  const [open, setOpen] = React.useState(false)
  const [form, setForm] = React.useState({
    title: tag.title,
    password: tag.password
  })

  const formEl = React.useRef(null)

  React.useEffect(() => {
    const subscription = rxOpenTag.subscribe(() => {
      setOpen(true)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  const onEnter = () => {
    setForm(tag)
  }

  const change = formUpdate(setForm)

  const submit = evt => {
    evt.preventDefault()

    if (!formEl.current.reportValidity()) {
      return
    }

    setOpen(false)
    sendWs(TAG, form)
  }

  const close = () => {
    setOpen(false)
  }

  return (
    <Dialog className="tag-dialog" open={open}
            TransitionProps={{ onEnter }}
            aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">部屋情報</DialogTitle>
      <DialogContent sx={{ width: '21em' }}>
        <form id="tag-form" ref={formEl} onSubmit={submit} noValidate>
          <FormGroup className="info-group">
            <TextField variant="standard" label="部屋名"
                       className="title"
                       inputProps={{ readOnly: !user.isMaster, maxLength: 20 }}
                       value={form.title} onChange={change.value('title')} />
          </FormGroup>
          <FormGroup className="info-group">
            <TextField variant="standard" label="合言葉"
                       className="password" sx={{ mt: '5px' }}
                       inputProps={{ readOnly: !user.isMaster, maxLength: 20 }}
                       value={form.password} onChange={change.value('password')} />
          </FormGroup>
        </form>
      </DialogContent>
      <DialogActions>
        <Button type="submit" form="tag-form" className="submit" color="primary"
                disabled={!user.isMaster}>
          設定
        </Button>
        <Button className="close" color="secondary"
                onClick={close}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default connect(
  state => ({
    tag: state.tag,
    user: state.user
  })
)(Tag)
